"use strict";
var default_group_detail_controller_1 = require("./default-group-detail.controller");
var templateUrl = require("./default-group-detail.html");
exports.defaultGroupDetail = {
    templateUrl: templateUrl,
    controller: default_group_detail_controller_1.DefaultGroupDetailController,
    controllerAs: "vm",
    bindings: {}
};



/** WEBPACK FOOTER **
 ** ./app/group-detail/default-group-detail.ts
 **/